import styled from "styled-components";

export const Page = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: radial-gradient(circle at top, #2e1065, #4c1d95 55%, #1e1b4b);
  font-family: "Inter", sans-serif;
`;

export const Card = styled.div`
  width: 100%;
  max-width: 460px;
  background: var(--wibat-papier);
  border-radius: 20px;
  padding: 40px 36px;
  box-shadow: 0 30px 60px -15px rgba(0, 0, 0, 0.4);
`;

export const Brand = styled.div`
  font-size: 24px;
  font-weight: 800;
  color: var(--wibat-ardoise);
  margin-bottom: 4px;
`;

export const Title = styled.h1`
  font-size: 24px;
  font-weight: 800;
  color: #1e1b4b;
  margin: 8px 0 4px;
`;

export const Subtitle = styled.p`
  font-size: 14px;
  color: var(--wibat-graphite);
  margin: 0 0 24px;
`;

export const Field = styled.div`
  margin-bottom: 16px;
`;

export const Label = styled.label`
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: var(--wibat-ardoise);
  margin-bottom: 6px;
`;

export const Input = styled.input`
  width: 100%;
  padding: 12px 14px;
  border: 1px solid var(--wibat-trait);
  border-radius: 10px;
  font-size: 15px;
  outline: none;
  transition: border-color 0.15s, box-shadow 0.15s;

  &:focus {
    border-color: var(--wibat-ardoise);
    box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.15);
  }
`;

export const SubmitButton = styled.button`
  width: 100%;
  margin-top: 8px;
  padding: 14px;
  border: none;
  border-radius: 10px;
  background: linear-gradient(135deg, var(--wibat-ardoise), var(--wibat-ardoise));
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: transform 0.15s, box-shadow 0.15s, opacity 0.15s;

  &:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 8px 20px rgba(124, 58, 237, 0.4);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const Error = styled.div`
  background: #fef2f2;
  border: 1px solid #fecaca;
  color: #b91c1c;
  border-radius: 10px;
  padding: 10px 12px;
  font-size: 13px;
  margin-bottom: 16px;
`;

export const Legal = styled.p`
  font-size: 11px;
  color: var(--wibat-n300);
  text-align: center;
  margin-top: 20px;
`;

export const SuccessIcon = styled.div`
  font-size: 44px;
  text-align: center;
  margin-bottom: 8px;
`;

export const SuccessText = styled.p`
  font-size: 15px;
  color: var(--wibat-ardoise);
  text-align: center;
  line-height: 1.5;

  strong { color: #1e1b4b; }
`;
